import { apiFetch } from '../../api/api';

/**
 * Fetch live printers for the active account
 */
export function fetchLivePrinters() {
  return apiFetch('/api/printmanager/printers');
}

/**
 * (future)
 * Assign printer to group
 */
export function assignPrinterGroup(printerId, printerGroupId) {
  return apiFetch('/api/printmanager/printers/group', {
    method: 'POST',
    body: { printerId, printerGroupId },
  });
}

export function triggerPrinterRescan(orgId) {
  return apiFetch(`/live/printers/${orgId}/rescan`, {
    method: 'POST',
  });
}
